import React from 'react';
import './VideoGrid.css';

// Import your thumbnail images
import thumb1 from '../../assets/images/video-thumb-1.jpg';
import thumb2 from '../../assets/images/video-thumb-2.jpg';
import thumb3 from '../../assets/images/video-thumb-3.jpg';
import thumb4 from '../../assets/images/video-thumb-4.jpg';
import thumb5 from '../../assets/images/video-thumb-5.jpg';
import thumb6 from '../../assets/images/video-thumb-6.jpg';

// Data for the video grid
const videoData = [
  {
    videoId: 'vo28mV8Y0LA?si=aeybbsyjhgAdzI1H', // Replace with real YouTube video ID
    thumbnail: thumb1,
    title: "Maize Sowing Could Increase By 6–7% This Kharif Season, Soybean Could Decline: WASEDA Global",
  },
  {
    videoId: '1Y6nIGGQqf4?si=ATkL8KBZWbNLa3j8',
    thumbnail: thumb2,
    title: "Trump, Tariffs And Trade Going To Keep International Markets Volatile In Coming Years: Sumit Gupta",
  },
  {
    videoId: 'XjCLsgFhKlM?si=hlO2JrkXOa4zO9wI',
    thumbnail: thumb3,
    title: "Luxury Living | Ram Rattan Group | TALKSHOW by RICHA MEHTA, Ep. 7 | With Mr. Sumit Gupta",
  },
  {
    videoId: 'rqpZa8W3QCQ?si=UGzznIyFhju8XdK7',
    thumbnail: thumb4,
    title: 'How Will Upcoming Elections Impact Indias Agri Commodities | Commodity Champions | CNBC TV18',
  },
  {
    videoId: 'kWTfJhwF8nU?si=zH89emO4eTNflpFg',
    thumbnail: thumb5,
    title: 'Trumps Hardline Tariff Policy & Strong Dollar Put Pressure On Silver & Other Commodities',
  },
  {
    videoId: 'LEacBym0kJM?si=JI0UrDUn8AS5yj_r',
    thumbnail: thumb6,
    title: 'What trade corridor shifts can be expected post-Covid?',
  },
  // Add more video objects here
];

const VideoGrid = () => {
  return (
    <section className="video-grid-section">
      <div className="video-grid-container">
        {videoData.map((video, index) => (
          <div key={index} className="video-card">
            <a href={`https://www.youtube.com/watch?v=${video.videoId}`} target="_blank" rel="noopener noreferrer" className="video-thumbnail-link">
              <img src={video.thumbnail} alt={video.title} />
              <div className="play-icon-overlay"></div>
            </a>
            <h4 className="video-title">{video.title}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VideoGrid;